import {useTranslation} from 'react-i18next';
import {ForwardIcon} from 'lucide-react';
import {useTheme} from 'styled-components';
import {Button, cn, useModalControls} from '@chekin/guestapp-ui-kit';
import ModalSheet from 'components/common/ModalSheet';
import ShareRegistrationLink from 'components/ModalSheets/ShareRegistrationLink';
import {getMainColor} from 'styled/common';
import {useLayoutMode} from 'hooks/useLayoutMode';

type Props = {
  className?: string;
};
export const ShareRegistrationLinkButton = ({className}: Props) => {
  const {t} = useTranslation();

  const {isOpen, closeModal, openModal} = useModalControls();
  const theme = useTheme();
  const layoutMode = useLayoutMode();
  if (layoutMode === 'kiosko') {
    return null;
  }

  return (
    <>
      <Button
        onClick={openModal}
        size="md"
        className={cn('m-auto gap-1 kiosko:gap-[18px]', className)}
        variant="link"
      >
        <ForwardIcon
          color={theme.colors.buttons.textButton}
          className={cn(
            `w-6 h-6 color-[${getMainColor(theme)}]`,
            'kiosko:w-14 kiosko:h-14',
          )}
        />
        {t('share_registration_link')}
      </Button>
      <ModalSheet
        isOpenModalSheet={isOpen}
        handleCloseModal={closeModal}
        withCloseButton
        maxWidth={'375px'}
      >
        <ShareRegistrationLink />
      </ModalSheet>
    </>
  );
};
